import getConst from "./getConst";
export function getCookie(name: string) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return "";
}

export function setCookie(name: string, value: string) {
    const domain = window.location.hostname;
    const expiresDate = new Date();
    expiresDate.setDate(expiresDate.getDate() + 30);
    const cookieValue = `${encodeURIComponent(name)}=${encodeURIComponent(
        value
    )}; domain=${domain}; path=/; expires=${expiresDate.toUTCString()}`;
    document.cookie = cookieValue;
}
export function removeCookie(name: string) {
    const domain = window.location.hostname;
    document.cookie = `${name}=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

export function getUserLoginCookie() {
    return getCookie(getConst("auth-token-name-v2"));
}
export function removeUserLoginCookie() {
    return removeCookie(getConst("auth-token-name-v2"));
}
export function setUserLoginCookie(value: string) {
    return setCookie(getConst("auth-token-name-v2"), value);
}
